"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.894 4.126a.7.7 0 0 1 .71.69l.02 1.301c1.223.138 2.063.645 2.602 1.33.609.772.755 1.674.772 2.244a.7.7 0 0 1-1.4.04c-.011-.406-.119-.97-.472-1.419-.327-.415-.943-.832-2.193-.832-1.285 0-1.913.421-2.236.832-.348.442-.441.996-.43 1.38.01.38.1.628.211.803.113.175.28.32.518.445.513.268 1.224.38 2.098.51l.054.007c.79.117 1.733.257 2.468.658.396.216.758.52 1.014.954q.38.651.368 1.536c-.016 1.43-.589 2.392-1.459 2.96-.595.39-1.283.563-1.918.63l-.017.992a.7.7 0 0 1-1.4-.024l.018-.994a4.5 4.5 0 0 1-1.941-.811c-.805-.598-1.414-1.527-1.414-2.76a.7.7 0 0 1 1.4 0c0 .72.339 1.257.849 1.636.528.392 1.22.595 1.817.595.679 0 1.352-.117 1.84-.436.44-.287.814-.79.825-1.804.005-.387-.074-.638-.175-.81a1.2 1.2 0 0 0-.477-.435c-.489-.267-1.184-.38-2.058-.51l-.078-.011c-.785-.117-1.72-.255-2.462-.643a2.7 2.7 0 0 1-1.047-.927q-.409-.638-.434-1.522c-.017-.593.116-1.505.73-2.285.54-.686 1.39-1.19 2.626-1.328l-.019-1.282a.7.7 0 0 1 .69-.71M3.001 8.18a2.2 2.2 0 0 1 2.2-2.203h1.82c2.177 0 4.119 1.549 4.119 3.662 0 1.674-1.217 2.993-2.804 3.47l2.691 4.146a.7.7 0 1 1-1.174.762l-3.061-4.715H4.407v4.484a.7.7 0 1 1-1.4 0v-5.184zm1.406 3.722H7.02c1.6 0 2.719-1.104 2.719-2.263S8.62 7.377 7.02 7.377H5.202a.8.8 0 0 0-.8.801z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyBrazilRealIcon24.js.map